export default {
    SET_LOCATIONS(state, payload) {
        state.locations = payload;
    },
}